// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes progress {
    0% {
      left: -100%;
    }
    100% {
      left: 100%;
    }
  }
  
  .animate-progress {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
    animation: progress 100s linear infinite;
  }
  .MuiButtonBase-root.button-progress {
    position: relative;
    width: 10rem; 
    height: 2.5rem; 
    background-color: #69319D; 
    border-radius: 0.5rem; 
    overflow: hidden;

  }
  .MuiTypography-root.progress-text {
   position: relative;
   z-index: 10;
   font-size: 14px;
   font-family: var(--font-family-primary);
   font-weight: 400; 
   color: #FDFCFF; 
   text-transform: capitalize;
  }
  .progress-container {
    display: flex; 
    flex-direction: column; 
    align-items: center; 
  }
  
  
  `, "",{"version":3,"sources":["webpack://./src/components/Reusable/ProgressButton/ProgressButton.css"],"names":[],"mappings":"AAAA;IACI;MACE,WAAW;IACb;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,sFAAsF;IACtF,wCAAwC;EAC1C;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;;EAElB;EACA;GACC,kBAAkB;GAClB,WAAW;GACX,eAAe;GACf,uCAAuC;GACvC,gBAAgB;GAChB,cAAc;GACd,0BAA0B;EAC3B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB","sourcesContent":["@keyframes progress {\n    0% {\n      left: -100%;\n    }\n    100% {\n      left: 100%;\n    }\n  }\n  \n  .animate-progress {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));\n    animation: progress 100s linear infinite;\n  }\n  .MuiButtonBase-root.button-progress {\n    position: relative;\n    width: 10rem; \n    height: 2.5rem; \n    background-color: #69319D; \n    border-radius: 0.5rem; \n    overflow: hidden;\n\n  }\n  .MuiTypography-root.progress-text {\n   position: relative;\n   z-index: 10;\n   font-size: 14px;\n   font-family: var(--font-family-primary);\n   font-weight: 400; \n   color: #FDFCFF; \n   text-transform: capitalize;\n  }\n  .progress-container {\n    display: flex; \n    flex-direction: column; \n    align-items: center; \n  }\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
